import {getCookie, isAndroidDevice, postData, slideToggle} from "../../../sources/js/functions/helpers";

(function () {
    const feedbackShow = document.querySelector('[data-feedback-button] > .button');
    const feedbackForm = document.querySelector('[data-feedback-form]');

    if (feedbackShow) {
        feedbackShow.addEventListener('click', () => slideToggle(feedbackForm));
    }

    if (location.hash) {
        const hash = location.hash;

        if (hash === '#feedback') {
            history.replaceState({}, "", location.href.replace(hash, ""));

            slideToggle(feedbackForm);

            document.querySelector('#feedback').scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
}());

(function () {
    const form = document.querySelector('#feedback .wpcf7-form');

    if (form) {
        const container = document.querySelector('.wpcf7-form__line_rating');

        if (container) {
            const stars = container.querySelectorAll('.wpcf7-list-item > label');

            const setRatingData = (count) => {
                stars.forEach((star, i) => {
                    i + 1 <= count ? star.classList.add('active') : star.classList.remove('active');
                });
            }

            stars.forEach((star) => {
                const radio_input = star.querySelector('input[name="user-rating"]');
                radio_input.checked ? setRatingData(radio_input.value) : false;

                star.addEventListener('click', function () {
                    const count = this.querySelector('input[name="user-rating"]').value;
                    setRatingData(count);
                });

                star.addEventListener('mouseover', function () {
                    const count = this.querySelector('input[name="user-rating"]').value;
                    setRatingData(count);
                });

                star.addEventListener('mouseout', () => {
                    stars.forEach((star) => {
                        const radio_input = star.querySelector('input[name="user-rating"]');

                        radio_input.checked ? setRatingData(radio_input.value) : false;
                    });
                });
            });
        }

        form.addEventListener('wpcf7mailsent', () => {
            const formWrap = document.querySelector('[data-feedback-form]');
            const formNotice = document.querySelector('[data-feedback-notice]');
            const formButton = document.querySelector('[data-feedback-button]');

            const formData = new FormData(form);
            const headers = {'Content-Type': 'application/json'}

            if (!!getCookie('__LK_2user_id') && !!getCookie('access_token')) {
                headers['X-AUTH-TOKEN'] = getCookie('access_token')
            }

            let obj = {};
            for (let entity of formData.entries()) {
                if (entity[0] === 'user-name' && !!entity[1]) obj.name = entity[1]

                if (entity[0] === 'user-phone' && !!entity[1]) obj.phone_number = entity[1].match(/\d+/g).join('')

                if (entity[0] === 'user-message' && !!entity[1]) obj.message = entity[1]

                if (entity[0] === 'user-rating' && !!entity[1]) obj.rating = +entity[1]
            }

            postData(API_FEEDBACK_ADD, obj, headers).then((response) => {
                if (formNotice) {
                    formButton.style.display = 'none'
                    formNotice.style.display = 'flex'

                    setTimeout(() => {
                        formButton.style.display = 'flex'
                        formNotice.style.display = 'none'
                    }, 10000);
                }

                if (isAndroidDevice() && obj.rating > 3) {
                    const modal = document.querySelector('[data-modal-feedback]');
                    if (modal) modal.classList.add('modal_active')
                }
            })

            form.reset();
            slideToggle(formWrap);
        });
    }
})();
